<ng-container *ngIf="isCreateMode() || isUpdateMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header
      [mode]="mode"
      createLabel="Ajouter une adresse"
      updateLabel="Modifier l'adresse"
    ></base-form-header>

    <mat-dialog-content>
      <!-- Form Fields -->
      <div class="space-y-4">
        <!-- Street Address -->
        <base-form-input label="Adresse" controlName="street" placeholder="Numéro et nom de rue"></base-form-input>

        <!-- Additional Address -->
        <base-form-input
          label="Complément d'adresse"
          controlName="additionalAddress"
          placeholder="Bâtiment, étage, appartement..."
        ></base-form-input>

        <!-- Postal Code and City -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <base-form-input
            label="Code postal"
            controlName="postalCode"
            placeholder="75001"
            type="text"
            maxlength="5"
            (blur)="validatePostalCode()"
          ></base-form-input>

          <base-form-input label="Ville" controlName="city" placeholder="Paris"></base-form-input>
        </div>

        <!-- Country -->
        <base-form-input
          label="Pays"
          type="select"
          controlName="country"
          [itemGroups]="countryGroups"
        ></base-form-input>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        type="submit"
        [mode]="mode"
        entityLabel="ADDRESS"
        (onCreate)="createItem()"
        (onUpdate)="updateItem()"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>

<ng-container *ngIf="isDeleteMode()">
  <form-modal-delete-base
    (onClose)="close()"
    (onDelete)="deleteItem()"
    [label]="defaults?.street || 'cette adresse'"
    [loading]="loading"
  ></form-modal-delete-base>
</ng-container>
